// the css is injected automatically
require('!style-loader!css-loader!postcss-loader!stylus-loader!./brochures.styl');

// this helps us remove everything exepct whats inside the body node
var strip = require("striphtml");
var getData = require('../../scripts/getdata')(MBGF.mbfa_apibase);
var validation = require('validation')(getData).brochures;
var checkbox = require("../checkbox/checkbox");
var getData = require('../../scripts/getdata')(MBGF.mbfa_apibase);
var parsing = require('parsing').brochures;

var dataSource = "";


var allBroschures = {};

function parse(text, next) {
    strip(require('raw!./brochures.html'), function(outputHtml) {
        var match = parsing.parse(text);

        var options;

        if (match) {

            var that = this;

            var requireData = "brochures";

            if (match[2]) {
                requireData += "?values=" + match[2];
            }
            else if (match[1]) {
                requireData += "?group=" + match[1];
            }

            //remove all charachters except 0-9 , and split numbers into an array
            //var id_array = match[0].replace(/[^0-9.+,]/g, "").split(',');

            getData(requireData, function (jsonString) {
                // check if the datasource is to be overridden
                if (that.dataSource && that.dataSource != "") {
                    jsonString = that.dataSource;
                }

                try {
                    if (typeof jsonString == "object") {
                        options = jsonString;
                    }
                    else {
                        options = JSON.parse(jsonString);
                    }

                }
                catch (e) {
                    options = false;
                }

                var insertOptions = "";
                /*if (options) {
                    for (var i = 0, ii = options.length; i < ii; i++) {
                        // what is this?
                        // check if brochure id exists in the array. If it does, add to string
                        if ((id_array.indexOf(options[i].value) > -1)) {
                            insertOptions += "[]" + options[i].label + " ";
                        }
                    }
                }*/

                if (options) {
                    var array = [];
                    for (var i = 0, ii = options.length; i < ii; i++) {

                        // Save the list so we can pick up the label later
                        allBroschures[options[i].value] = options[i];

                        if( options[i].hidden != true && options[i].outofstock != true ) {
                            array[i] = "[] " + options[i].value + " -> " + options[i].label;

                            if (options[i].selected) {
                                array[i] = array[i].replace("[]", "[x]");
                            }
                        }
                    }
                    insertOptions = array.join(" ");
                }

                if (insertOptions != "") {
                    if (match[3] == "*") {
                        var container = document.createElement("div");
                        container.innerHTML = outputHtml;
                        var domObj = container.firstChild;
                        domObj.setAttribute("data-required", "true");

                        // add a "required" class to the parent node
                        domObj.setAttribute("class", domObj.getAttribute("class") + " required");

                        outputHtml = container.innerHTML;

                        outputHtml = outputHtml.replace(" = []", "* = " + insertOptions);
                    }
                    else {
                        outputHtml = outputHtml.replace("[]", insertOptions);
                    }
                }

                text = text.replace(match[0], outputHtml);
                next(text);
            });
        }
        else {
            next(text);
        }
    });
};

function validate(context, err) {
    var value = checkbox.get(context);
    var required = context.getAttribute("data-required") == "true";

    return validation.validate(value, required)
        .then(function(validationResult) {
            validationResult = !err ? validationResult : err;
            checkbox.validate(context);
            return validationResult.valid;
        });
}

function init( formRoot, meta, next ) {
    var brochuresOverrideForm = document.querySelector('#form-select-brochures');
    var context = formRoot.querySelector('[data-module="brochures"]');

    if( brochuresOverrideForm && context ) {
        var currentClass = context.getAttribute('class') || '';
        context.setAttribute('class', currentClass + ' hidden');

        // a form that overrides this module visually exists
        var brochureCheckboxes = document.querySelectorAll('input[title="brochure"]');

        // for a chosen brochure, tick corresponding checkbox in form
        var formCheckbox, brochureId;
        for(i = 0, ii = brochureCheckboxes.length; i < ii; i++) {
            brochureCheckboxes[i].addEventListener('change', function() {
                brochureId = this.id;
                formCheckbox = context.querySelector('input[value="' + brochureId + '"]');
                formCheckbox.checked = this.checked;

                // bind listener(s) to button(s) in 'dina valda broschyrer' section
                var removeBrochureButtons = document.querySelectorAll('button.remove-brochure');

                if (removeBrochureButtons) {
                    for(i = 0, ii = removeBrochureButtons.length; i < ii; i++) {
                        removeBrochureButtons[i].addEventListener('click', function() {
                            formCheckbox = context.querySelector('input[value="' + this.parentElement.id + '"]');
                            formCheckbox.checked = false;
                        });
                    }
                }
            });
        }
    }
    next(formRoot);
}

function get(context) {
    var value = checkbox.get(context);
    var newValue = [];
    var all = value.split(',');
    for ( var i = 0, ii = all.length; i < ii; i++ ) { 
        var brochure = all[i];
        if (allBroschures[brochure]) {
            newValue.push(brochure + ' - ' + allBroschures[brochure].brochurename);
        }
    }
    return newValue.join(', ');
}

function reset(context) {
    checkbox.reset(context);
}

module.exports = {
    parse: parse,
    validate: validate,
    init: init,
    get: get,
    dataSource: dataSource,
    reset: reset
};



// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/brochures/brochures.js